import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const brand = {
  reachBlue: 'var(--reach-blue)',
  border: 'rgba(5, 5, 51, 0.1)',
  navy: '#050A30',
};

function getTellerDisplayName(teller) {
  return teller?.i18n?.en_US?.name?.trim() || 'N/A';
}

const PasswordModal = ({ open, onClose, tellers = [], translations = {} }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
    <DialogTitle sx={{ fontFamily: 'BrightstarSans-Bold' }}>
      {translations.password || 'Password Verification'}
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0 }}>
      <TableContainer>
        <Table size='small' aria-label='retailer passwords'>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: 'rgba(5, 10, 48, 0.04)',
                '& .MuiTableCell-head': {
                  fontFamily: 'BrightstarSans-Bold',
                  color: brand.navy,
                  borderBottomColor: brand.border,
                },
              }}
            >
              <TableCell width={56}>#</TableCell>
              <TableCell>{translations.password || 'Password'}</TableCell>
              <TableCell>{translations.name || 'Name'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tellers.map((teller, index) => (
              <TableRow
                key={teller.tellerOid ?? `${teller.tellerId}-${index}`}
                sx={{
                  '&:last-child td': { borderBottom: 0 },
                  '& .MuiTableCell-root': {
                    fontFamily: 'BrightstarSans-Regular',
                    color: brand.reachBlue,
                    borderBottomColor: brand.border,
                  },
                }}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell sx={{ fontFamily: 'BrightstarSans-Bold' }}>
                  {teller.password}
                </TableCell>
                <TableCell>{getTellerDisplayName(teller)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{translations.close || 'Close'}</Button>
    </DialogActions>
  </Dialog>
);

export default PasswordModal;
